import React from 'react'

export default function StepDots({ step, of }) {
  return (
    <div className="pps-stepdots" aria-label={`Step ${step} of ${of}`}>
      {Array.from({ length: of }).map((_, i) => (
        <span key={i} className={`pps-stepdot${i + 1 <= step ? ' is-active' : ''}`} />
      ))}
    </div>
  )
}
